export default "#gantt{height:700px}#reset-this-root{all:initial}#reset-this-root *{all:unset}";